var React = require('react');

function ArrowButtonLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"arrow-button-left","transform":"translate(-16.000000, -15.000000)","stroke":"#000000"},React.createElement("g",{"id":"arrow","transform":"translate(25.000000, 25.000000) scale(-1, 1) translate(-25.000000, -25.000000) translate(16.000000, 16.000000)"},[React.createElement("line",{"x1":"-6.82121026e-13","y1":"8.75","x2":"17.5","y2":"8.75","id":"Path-5","key":0}),React.createElement("polyline",{"id":"Path-6","points":"8.75 0 17.5 8.75 8.75 17.5","key":1})]))));
}

ArrowButtonLeft.defaultProps = {"viewBox":"0 0 19 19","version":"1.1"};

module.exports = ArrowButtonLeft;

ArrowButtonLeft.default = ArrowButtonLeft;
